export * from './client.http.module';
export * from './client.http.utils';

export * from './entity/client.error.code';
export * from './entity/client.error.type';
export * from './entity/client.error.factory';
export * from './entity/client.error.response';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/index.ts